export * from './spacing';
export * from './palette';
export * from './pinnedStreamPosition';
export * from './fonts';

export enum СssSetNaming {
    SPACING = 'spacing',
    PALETTE = 'palette',
    PINNED_STREAM_POSITION = 'pinnedStreamPosition',
}
